import { render, staticRenderFns } from "./Totalprogram.vue?vue&type=template&id=51fbf6d6&"
import script from "./Totalprogram.vue?vue&type=script&lang=js&"
export * from "./Totalprogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports